export default __webpack_public_path__ + "20d8ae0d01f75170bd8982afb15e831e.png";